export default {
  'da cheng international asset management co. ltd': '大成国际资产管理有限公司',
  'product': '产品',
  'analysis report': '分析报告',
  'resource': '资源',
  'me': '我',
  'login': '登录',
  'logout': '登出',
  'username': '用户名',
  'password': '密码',
  '{1} is required': '请输入{1}',
  'service statement': '服务条款',
  'user profile': '用户信息',
  'accept': '同意',
  'reject': '不同意',
  'email': '邮箱',
  'contact person': '联系人',
  'phone no': '联系电话',
  'fax': '传真号码',
  'lanaguage': '首选语言',
  'simplified chinese': '简体中文',
  'traditional chinese': '繁体中文',
  'english': '英文',
  'save': '保存',
  'the format of {1} is not correct': '{1}格式不正确',
  'position': '职位',
  'website': '官方主页',
  'save successfully': '保存成功',
  'save failed': '无法保存',
  'documents': '用户文件',
  'upload document': '上传文件',
  'file type to upload': '上传的文件类型',
  'type one': '文件类型1',
  'type two': '文件类型2',
  'type three': '文件类型3',
  'upload successfully': '上传成功',
  'upload failed': '上传失败',
  'yyyy-mm-dd hh:mm:ss': 'YYYY年MM月DD日 HH:mm:ss',
  'last updated': '更新时间',
  'file name': '文件名',
  'status': '状态',
  'uploaded': '已上传',
  'accepted': '已接受',
  'rejected': '已拒绝',
  'home phone': '家庭电话',
  'mobile phone': '移动电话',
  'office phone': '办公电话',
  'employment': '就业情况',
  'employed': '受雇',
  'self-employed': '自雇',
  'retired': '退休',
  'others': '其它',
  'remark': '备注',
  'country': '国家',
  'china': '中国',
  'hong kong': '中国香港特别行政区',
  'employer': '受雇机构',
  'products': '产品',
  'introduction': '概要',
  'performance': '基金表现',
  'please select product': '请选择产品',
  'analysis reports': '分析报告',
  'download': '下载',
  'all products': '全部产品',
  'report name': '报告名',
  'report': '报告',
  'report type': '类型',
  'operation': '操作',
  'all types': '全部类型',
  'readed': '已读',
  'unread': '未读',
  'prev': '上一页',
  'next': '下一页',
  'search': '搜索',
  'language': '语言',
  'no data': '无数据',
  'upload': '上传文件',
  'resources': '资源',
  'resource name': '资源名',
  'name': '名称',
  'resource type': '资源类型',
  'user account is locked': '账户已被锁住',
  'bad credentials': '用户名或者密码不正确',
  'period': '时间段',
  '1 month': '近1月',
  '3 months': '近3月',
  '1 year': '近1年',
  '3 years': '近3年',
  'all': '成立以来',
  'statistics': '统计数据',
  'comparable indexes': '参照指数',
  'the page does not exist': '访问的页面不存在',
  'change password': '修改密码',
  'old pass': '旧密码',
  'new pass': '新密码',
  'confirm': '确认密码',
  'new password': '新密码',
  'your password is expired, please change your password.': '您的密码已经过期，请修改密码',
  'change': '修改',
  'cancel': '取消',
  'length of new password must be 8 to 30': '新密码必须8到30个字符',
  'new password and confirm password should be the same': '新密码和确认密码不一致',
  'password update successfully': '密码修改成功',
  'password update failed, please make sure the old password is correct': '密码修改失败，请确认旧密码是否正确',
  '* please upload pdf, word, excel, png or jpg file. the maximum file size is 5mb.': '* 支持的文件类型是PDF, Word, Excel, PNG 或者JPGE，最大的能上传的文件大小是 5MB',
  'activate account': '激活帐号',
  'the activate link is invalid or expired': '激活链接无效或者已过期',
  'account activate successfully': '帐号激活成功',
  'account activate failed. please make sure the link is valid': '帐号激活失败，请确定激活链接是否有效',
  'forget password?': '忘记密码?',
  'please enter the username': '请输入账号',
  'find password': '找回密码',
  'find password failed. please make sure the username is correct': '无法找回密码，请确定帐号是否正确',
  'the reset password link is sent to your email. please use the link to reset your password': '重设密码链接已发到您的邮箱，请使用链接重设密码',
  'reset password': '重设密码',
  'the reset password link is invalid or expired': '重设密码链接无效或者已过期',
  'password reset successfully': '密码重设成功',
  'password reset failed. please make sure the link is valid': '密码重设失败，请确定重设链接是否有效',
  'new email': '新邮箱',
  'the format of email is not correct': '邮箱的格式不正确',
  'the activate link is sent to your new email address. please use the link to activate the new email': '新邮箱激活链接已发到您的新邮箱，请使用链接激活新邮箱',
  'change email': '修改邮箱',
  'change email failed, please make sure the email is correct': '无法修改邮箱，请确定邮箱是否正确',
  'ok': '确定',
  'activate new email': '激活新邮箱',
  'the new email is activated successfully.': '新邮箱激活成功',
  'activate new email failed. please make sure the link is valid.': '无法激活新邮箱，请确定链接是否有效',
  'download selected': '下载选中报告',
  'privacy': '隐私声明',
  'dci asset management company limited., all rights reserved.': '大成国际资产管理有限公司版权所有',
  'dc fund': '大成国际',
  'by clicking "login", you agree to ': '按 [登录] 即表示您同意 ',
  'our privacy statement': '隐私声明',
  'id/passport no': '身份证或护照号码',
  'if changing this field, please provide supporting documents': '如变更此栏，请联系您的客户经理并提供相关证明文件',
  'chinese name': '中文名',
  'english name': '英文名',
  'nationality': '国籍',
  'birthday': '出生日期',
  'country of birth': '出生国家',
  'residential address': '住宅地址',
  'business address': '办公地址',
  'type': '类型',
  'disclaimer': '免责声明',
  'disclaimer-content': '本文件由大成国际资产管理有限公司（「大成国际」）发布，并未经香港证券及期货事务监察委员会审核。投资涉及风险，投资者不应该仅根据本文件就做出投资决策。本文件内的任何建议或估计都是在一般化的基础上做出的，投资者不应将其作为投资依据。大成国际对投资者因信赖本文件做出的投资决定而造成的损失不承担任何责任。文件所提供的信息并不含任何要约、招揽、或交易文件中提及的投资产品或服务。投资者应确定大成国际产品部人员已向阁下解释与大成国际签订的投资管理协议是否适合阁下，及应参阅该投资管理协议内之相关风险披露声明。专户投资份额的价值及收益可跌可升。过去表现或任何预测，未必代表专户将来或有可能达至的表现。大成国际或任何附属机构对专户的投资回报并不承担任何责任，亦不作出任何保证或担保。大成国际尽力确保此文件所包含信息准确和可靠，保证其准确性和可靠性。大成国际对于信息不准确或信息遗漏所造成的损失不承担任何责任。未经大成国际的许可，不得抄袭、复制或提供此文件给第三者。',
  'disclaimer-data-content': '大成国际尽力确保相关统计数据准确和可靠，但并不保证其准确性、可靠性及完整性。大成国际对于信息不准确或信息遗漏所造成的损失不承担任何责任。',
  'the email exists in the system. please use another email': '邮箱已经被占用，请使用其它邮箱',
  'net value': '基金净值',
  'cumulative returns': '累计收益率',
  'annualized returns': '年化收益率',
  'annualized volatility': '年化波动率',
  'information ratio': '信息比率',
  'max drawdown': '最大回撤',
  "i've read the notice aboved": '我已阅读上述通知',
  'company name': '机构名称',
  'ci no': '公司注册号',
  'registration area': '注册地',
  'registration date': '注册成立日期',
  'business type': '营业性质及目的',
  'registration address': '注册地址',
  'please select file type': '请选择文件类型',
  'dial code': '区号',
  '{1} and area code should both exist or not exist': '{1}和区号需同时存在或者同时为空',
  'this portal is for client only, for manager and compliance users, please use admin portal.': '该网站仅供客户使用，如果你是客户经理或合规用户，请使用后台管理网站。',
  'download net value': '下载基金净值',
  'uploading the document, please wait': '文件上传中，请稍等',
  'captcha': '验证码',
  'imageid is blank': '验证码无效',
  'code is blank': '验证码不能为空',
  'code is not matched': '验证码不正确',
  'code is expired': '验证码已过期',
  'indexes': '指数',
  'position details': '持仓明细',
  'total position market value (Hong Kong Dollar)': '总持仓市值（港币）',
  'position fund count': '持仓基金数',
  'floating profit/loss (Hong Kong Dollar)': '浮动盈亏(港币)',
  'cumulative return rate': '累计收益率',
  'position date': '持仓日期',
  'fund name': '基金名称',
  'base currency': '基础货币',
  'household registration number': '户口号码',
  'fund category': '基金类别',
  'fund category currency': '基金类别货币',
  'position quantity': '持仓数量',
  'cost price': '成本价',
  'net asset value per unit': '基金单位净值',
  'position cost (Hong Kong Dollar)': '持仓成本(港币)',
  'position cost': '持仓成本(原币)',
  'position market value (Hong Kong Dollar)': '持仓市值(港币)',
  'position market value': '持仓市值(原币)',
  'converted market value': '折算市值（元）',
  'floating profit/loss': '浮动盈亏(原币)',
  'profit/loss rate': '盈亏率',
  'position ratio': '持仓占比',
  'account': '账户',
  'please select account': '请选择账户',
  'export report': '导出报表',
  'query': '查询',
  'total records': '共 {1} 条记录',
  'first page': '首页',
  'last page': '尾页',
  'float profit/loss and return rate are calculated based on data since 2014.': '浮动盈亏及收益率基于2014年以来数据计算。',
  'cost price, floating profit/loss and return rate are calculated based on data since 2014.': '成本价、浮动盈亏及收益率基于2014年以来数据计算。',
  'holdings': '持仓',
  'transactions': '交易记录',
  'transaction date': '交易日期',
  'transaction tranNo': '交易编号',
  'transaction type': '交易类型',
  'amount': '金额',
  'shares': '份额',
  'net value (txn)': '净值',
  'fee': '费用',
  'transaction number': '交易编号',
  'buy': '买入',
  'sell': '卖出',
  'no holdings data': '暂无持仓数据',
  'no transactions data': '暂无交易记录',
  'product information only for reference': '以下产品信息仅供投资者参考，实际产品信息以投资者与管理人签署的相关协议及不时地修订为准。',
  'fund code': '基金代码',
  'fund class': '基金类别',
  'total market value': '总市值',
  'data cutoff value': '数据截止',
  'yesterday return': '昨日收益',
  'holding profit/loss': '持有收益',
  'cumulative profit/loss': '累计盈亏',
  'performance trend': '业绩走势',
  '6 months': '近6个月',
  'position': '持仓',
  'time range': '时间范围',
  'start date': '开始日期',
  'end date': '结束日期'
}
